import { NgModule } from '@angular/core';
import { DatePickerB3, Dropdownb3, Dropdownb3icon, InputB3, InputB3Decimal, Textareab3 } from '@components/form.elements';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { FormsModule } from '@angular/forms';
import { UtilsModule } from '@app/modules/utils.module';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule, UtilsModule],
  declarations: [InputB3, InputB3Decimal, Dropdownb3, Textareab3, DatePickerB3, Dropdownb3icon],
  exports: [InputB3, InputB3Decimal, Dropdownb3, Textareab3, DatePickerB3, Dropdownb3icon],
})
export class CustomFormsModule {}
